//Polyfill Promise for ie
require('es6-promise/auto');

import thunkMiddleware from 'redux-thunk';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import React from 'react';
import { createStore, applyMiddleware, compose } from 'redux';

import reducer from './reducers';
import { addFilterOption } from './actions/filter-options';
import { setFilter } from './actions/filter';
import { setStaticHtml } from './actions/posts';
import { setPageTotal } from './actions/page';
import { setConfig } from './actions/config';
import DefaultConfiguration from './config';
import ResourceGridApp from './components/resource-grid';
import { replaceState, popState } from './history';

let store = createStore(
    reducer,
    compose(
        applyMiddleware(thunkMiddleware),
        window.devToolsExtension ? window.devToolsExtension() : f => f
    )
);

let el = document.getElementById('post-grid');

if (el) {
    let config = Object.assign({}, DefaultConfiguration);

    if (
        el.hasAttribute('data-post-type') &&
        el.getAttribute('data-post-type')
    ) {
        config.postType = el.getAttribute('data-post-type');
    }
    store.dispatch(setConfig(config));

    if (
        el.hasAttribute('data-filter-options') &&
        el.getAttribute('data-filter-options')
    ) {
        let filterOptions = [];
        try {
            filterOptions = JSON.parse(el.getAttribute('data-filter-options'));
        } catch (err) {
            console.warn(err);
        }

        for (var filterOption of filterOptions) {
            store.dispatch(
                addFilterOption(
                    filterOption.taxonomy.name,
                    filterOption.taxonomy.label,
                    filterOption.terms
                )
            );
        }
    }

    if (window.history.state) {
        popState(window.history.state, store.dispatch);
    } else {
        store.dispatch(setStaticHtml(el.innerHTML));

        if (
            el.hasAttribute('data-page-total') &&
            el.getAttribute('data-page-total')
        ) {
            store.dispatch(setPageTotal(el.getAttribute('data-page-total')));
        }

        if (el.hasAttribute('data-filter') && el.getAttribute('data-filter')) {
            let filter = {};
            try {
                filter = JSON.parse(el.getAttribute('data-filter'));
            } catch (err) {
                console.warn(err);
            }

            store.dispatch(setFilter(filter));
            replaceState(store.getState());
        }
    }

    render(
        <Provider store={store}>
            <ResourceGridApp />
        </Provider>,
        el
    );

    window.addEventListener('popstate', function(e) {
        if (e.state) {
            popState(e.state, store.dispatch);
        }
    });
}
